import { SVGProps } from 'react'

export const MicOffWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.49967 6.26634V3.33301C9.49967 2.22844 8.60424 1.33301 7.49967 1.33301C6.7146 1.33301 6.03517 1.78535 5.70781 2.44363M7.49967 12.6663V14.6663M7.49967 12.6663C4.92235 12.6663 2.83301 10.577 2.83301 7.99967V6.66634M7.49967 12.6663C10.077 12.6663 12.1663 10.577 12.1663 7.99967V6.66634M4.83301 14.6663H10.1663M0.833008 1.33301L14.1663 14.6663M7.49967 9.99967C6.39511 9.99967 5.49967 9.10424 5.49967 7.99967V5.99967L8.91474 9.41303C8.55275 9.77546 8.05239 9.99967 7.49967 9.99967Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
